import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { FaFileAlt, FaTools, FaLightbulb } from 'react-icons/fa';
import './LandingPage.css';

const LandingPage = () => {
  const navigate = useNavigate();
  const { isAuthenticated, loading } = useAuth();

  const handleOptionClick = (type) => {

    // Wait until auth state is loaded
    if (loading) return;

    // If not logged in → go to auth
    if (!isAuthenticated) {
      navigate(`/auth/${type}`);
      return;
    }

    // If logged in → go directly
    if (type === 'complaint') navigate('/complaint/new');
    if (type === 'request') navigate('/request/new');
    if (type === 'suggestion') navigate('/suggestion/new');
  };

  // Prevent UI flicker before auth loads
  if (loading) return null;

  return (
    <div className="landing-page">
      <header className="header">
        <div className="container">
          <h1 className="logo">AplaSevak</h1>
          <p className="tagline">Your Voice for Better Ward Services</p>
        </div>
      </header>

      <main className="main-content">
        <div className="container">
          <section className="hero">
            <h2>Welcome to Ward Complaint Management System</h2>
            <p>
              Connect with your local corporator and get your civic issues resolved
            </p>
          </section>

          <section className="options-grid">

            <div
              className="option-card"
              onClick={() => handleOptionClick('complaint')}
            >
              <div className="option-icon">
                <FaFileAlt size={48} />
              </div>
              <h3>Book Complaint</h3>
              <p>
                Report issues related to water, electricity, drainage, roads, and more
              </p>
              <button className="btn btn-primary">
                File Complaint
              </button>
            </div>

            <div
              className="option-card"
              onClick={() => handleOptionClick('request')}
            >
              <div className="option-icon">
                <FaTools size={48} />
              </div>
              <h3>Service Request</h3>
              <p>
                Request civil services for your area and community
              </p>
              <button className="btn btn-primary">
                Request Service
              </button>
            </div>

            <div
              className="option-card"
              onClick={() => handleOptionClick('suggestion')}
            >
              <div className="option-icon">
                <FaLightbulb size={48} />
              </div>
              <h3>Suggestions</h3>
              <p>
                Share your ideas for improving ward amenities and services
              </p>
              <button className="btn btn-primary">
                Give Suggestion
              </button>
            </div>

          </section>

          <section className="info-section">
            <h3>How It Works</h3>
            <div className="steps">
              <div className="step">
                <div className="step-number">1</div>
                <h4>Register or Login</h4>
                <p>Create your account or login using OTP</p>
              </div>
              <div className="step">
                <div className="step-number">2</div>
                <h4>Submit Issue</h4>
                <p>File complaint, request service, or give suggestion</p>
              </div>
              <div className="step">
                <div className="step-number">3</div>
                <h4>Track Progress</h4>
                <p>Get real-time updates on your submissions</p>
              </div>
              <div className="step">
                <div className="step-number">4</div>
                <h4>Get Resolution</h4>
                <p>Stay informed until issue is resolved</p>
              </div>
            </div>
          </section>

        </div>
      </main>

      <footer className="footer">
        <div className="container">
          <p>&copy; 2026 AplaSevak. All rights reserved.</p>
        </div>
      </footer>
    </div>
  );
};

export default LandingPage;